import { Input, Td, Tr } from "@chakra-ui/react";
import {
  OrcamentoDeptoCategoria,
  OrcamentoDeptoItem
} from "models/orcamento_departamento";
import { useRef, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface IAddOrcRow {
  setError: (valor: boolean) => void;
  setErrorTitle: (valor: string) => void;
  setErrorMsg: (valor: string) => void;
  index: number;
  calculaValor: (value: OrcamentoDeptoItem[]) => number;
  changeItem1: (item: OrcamentoDeptoCategoria) => void;
  item: OrcamentoDeptoCategoria | undefined;
  setCategoryItens: (value: OrcamentoDeptoItem[]) => void;
}

const AddOrcRow = ({
  calculaValor,
  changeItem1,
  index,
  item,
  setCategoryItens,
  setError,
  setErrorMsg,
  setErrorTitle,
}: IAddOrcRow) => {
  const [descricao, setDescricao] = useState("");
  const [total, setTotal] = useState(0);
  const produtoRef = useRef(null);

  const changeDescricao = (item: string) => {
    setDescricao(item);
  };

  const changeValor = (item: string) => {
    setTotal(Number(item));
  };

  const addRow1 = (valor: string, item: OrcamentoDeptoCategoria) => {
    const dataValue = Number(valor);


    const list = item.OrcamentoDeptoItem;
    setTotal(dataValue);

    if (Number(valor) > 0) {
      const add: OrcamentoDeptoItem = {
        descricao: descricao,
        orcamentoDeptoCategoriaId: "",
        valorTotal: Number(total),
        id: "",
        nivel: index,
      };

      const existe = list.find((val) => val.descricao === descricao);

      if (existe) {
        setError(false);
      } else {
        list.push(add);
        item.valor = calculaValor(list);
        item.OrcamentoDeptoItem = list;
        setCategoryItens(list);
        changeItem1(item);

        setDescricao("");

        setTotal(0);
        produtoRef.current.focus();
      }
    }
  };
  return (
    <Tr>
      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
        0.0
      </Td>
      <Td fontSize={{ sm: "14px" }} borderColor="transparent" >
        <Input
          isRequired={false}
          fontSize="sm"
          ref={produtoRef}
          value={descricao}
          ms={{ base: "0px", md: "0px" }}
          type="text"
          placeholder="Digite a Descrição"
          fontWeight="500"
          name={`descricao-${index}`}
          border={"none"}
          size="md"
          onChange={(e) => changeDescricao(e.target.value)}
        />
      </Td>
      <Td fontSize={{ sm: "14px" }} borderColor="transparent" >
        <Input
          isRequired={false}
          fontSize="sm"
          value={total}
          ms={{ base: "0px", md: "0px" }}
          type="text"
          placeholder="valor"
          name={`valor-${index}`}
          fontWeight="500"
          border={"none"}
          size="md"
          onChange={(e) => changeValor(e.target.value)}
          onBlur={(e) => addRow1(e.target.value, item)}
        />
      </Td>
      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
        {formatNumber(Number(total))}
      </Td>
      <Td></Td>
    </Tr>
  );
};

export default AddOrcRow;
